import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-forgot-pasword-confirmation',
  templateUrl: 'forgot-pasword-confirmation.html'
})

export class ForgotPasswordConfirmationPage {

	constructor(public navCtrl: NavController) {

	}

    /**
     * goToLogin
     */
    public goToLogin() {
        this.navCtrl.push(LoginPage, {});
    }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-pasword-confirmation/forgot-pasword-confirmation.ts